module.exports = __webpack_public_path__ + "static/media/products.540c471c.svg";